var map = {
	"./back.svg": "965d",
	"./burger.svg": "48b7",
	"./checkmark.svg": "93fc",
	"./checkmark_white.svg": "7fb0",
	"./cross.svg": "fb81",
	"./cross_white.svg": "896b",
	"./delete.svg": "5600",
	"./elem_air.svg": "5d90",
	"./elem_earth.svg": "8fcb",
	"./elem_fire.svg": "132d",
	"./elem_water.svg": "b5bd",
	"./element_to_constellation.svg": "23b2",
	"./home.svg": "23a7",
	"./home_logo.svg": "8ed0",
	"./infos.svg": "84ed",
	"./minus.svg": "111a",
	"./move.svg": "7730",
	"./pause.svg": "8161",
	"./play.svg": "be47",
	"./playlist.svg": "f7d6",
	"./plus.svg": "fdd8",
	"./refresh.svg": "d72a",
	"./remove.svg": "8911",
	"./share.svg": "c151",
	"./show.svg": "8b0b",
	"./song.svg": "82c9",
	"./spotify.svg": "b6b9",
	"./stop.svg": "70e2",
	"./stop_square.svg": "c36d",
	"./warning.svg": "d84f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd78";